import { lightTheme } from '@/customTheme'
import { useTranslation } from 'react-i18next'
import { Z_INDEX } from '@/constants/z-index'
import { Tooltip as BaseTooltip } from 'baseui/tooltip'

interface FloatingTooltipProps {
  tooltipText: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
  margin?: number
  design?: 'default' | 'compact'
  maxWidth?: number | string
  textAlign?: 'left' | 'center' | 'right'
  ignoreBoundary?: boolean
  zIndex?: number
}

function FloatingTooltip({ 
  tooltipText, 
  placement = 'top', 
  margin,
  design = 'default',
  maxWidth,
  textAlign = 'left',
  ignoreBoundary,
  zIndex
}: FloatingTooltipProps) {
  const [t] = useTranslation()
  
  const isCompact = design === 'compact'
  const typography = isCompact ? lightTheme.typography.Small11regular : { fontSize: '12px', fontWeight: 400 }
  const lineHeight = isCompact ? '16px' : undefined
  const padding = isCompact ? '8px' : '8px'
  
  return (
    <BaseTooltip
      isOpen={true}
      content={() => <>{t(tooltipText)}</>}
      showArrow
      placement={placement}
      popoverMargin={margin ?? 4}
      ignoreBoundary={ignoreBoundary}
      overrides={{
        Inner: {
          style: ({ $theme }) => ({
            fontFamily: $theme.typography.font400.fontFamily,
            ...typography,
            ...(lineHeight && { lineHeight }),
            textAlign,
            color: lightTheme.colors.white,
            backgroundColor: lightTheme.colors.blackGray,
            padding,
            ...(maxWidth && { maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth }),
          }),
        },
        Body: {
          style: () => ({
            zIndex: zIndex ?? Z_INDEX.POPOVER_HIGH,
            backgroundColor: lightTheme.colors.blackGray,
            pointerEvents: 'none',
            ...(maxWidth && { maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth }),
          }),
        },
        Arrow: {
          style: () => ({
            zIndex: zIndex ?? Z_INDEX.POPOVER_HIGH,
            backgroundColor: lightTheme.colors.blackGray,
          }),
        },
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: zIndex ?? Z_INDEX.POPOVER_HIGH,
          pointerEvents: 'none',
        }}
      ></div>
    </BaseTooltip>
  )
}

export default FloatingTooltip
